$("body").on("click", ".gallery-open" ,function () {
    $(".gallery-lightbox").fadeIn();
});

$(".gallery-close, .overlay").click(function () {
    $(".gallery-lightbox").fadeOut();

    $("html").css({"overflow": "visible"});
});

function lightBoxResize() {
    var vHeight = $(window).height(),
        vWidth = $(window).width(),
        lightBox = $('.gallery-lightbox');

    lightBox.css({"height":vHeight,"width":vWidth});

    /*if(lightBox.css("display") !== "none"){

        $("#homepage-gallery").find(".content").css({"height": vHeight * 0.95,"width": vWidth * 0.95});

        $("#homepage-gallery").find(".content").css({"height": $(".voucher").height(),"width": $(".voucher").width()});
    }*/

}

$(window).on("load resize",function () {
    lightBoxResize();
});

$(".switch-content:first-of-type, .switch-title:first-of-type, .switch-button:first-of-type").addClass("active");

$("#homepage-gallery").nl_switch_content();

var leftArrow = $(".move-left"),
    rightArrow = $(".move-right");

function handleGalleryArrows() {

    if($(".switch-content:first-of-type").hasClass("active")){
        leftArrow.addClass("disabled");
    }
    else{
        leftArrow.removeClass("disabled");
    }



    if($(".switch-content:last-of-type").hasClass("active")){
        rightArrow.addClass("disabled");
    }
    else{
        rightArrow.removeClass("disabled")
    }
}

function handleNumber() {
    if($("#homepage-gallery").find(".active").length){

        console.log("test");

        var currentId = parseInt($(".active").attr("class").match(/\d+/)[0]),
            lastId = parseInt($(".switch-content:last-of-type").attr("class").match(/\d+/)[0]);

        $(".photo-number").find(".number").text(currentId + 1);
        $(".photo-number").find(".of").text(lastId + 1);

    }
}

handleGalleryArrows();
handleNumber();

$(rightArrow).click(function () {
    var currentId = parseInt($(".active").attr("class").match(/\d+/)[0]),
        next = currentId + 1;

    if(!$(".switch-content:last-of-type").hasClass("active")){

        $(".switch-area").find(".active").hide().css("opacity","0").removeClass("active");
        $(".active").removeClass("active");

        $(".item-" + next + "").addClass("active").show().css("opacity", "1");
    }

    handleGalleryArrows();
    handleNumber();
});

$(leftArrow).click(function () {
    var currentId = parseInt($(".active").attr("class").match(/\d+/)[0]),
        prev = currentId - 1;


    if(!$(".switch-content:first-of-type").hasClass("active")){
        $(".switch-area").find(".active").hide().css("opacity","0").removeClass("active");
        $(".active").removeClass("active");

        $(".item-" + prev + "").addClass("active").show().css("opacity", "1");
    }

    handleGalleryArrows();
    handleNumber();
});



